import axios, {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig
} from 'axios'
import qs from 'qs'

import { config } from '@/config/axios/config'
import errorCode from './errorCode'

const { result_code, base_url, request_timeout } = config

const service: AxiosInstance = axios.create({
  baseURL: base_url,
  timeout: request_timeout,
  withCredentials: false,
  paramsSerializer: (params) => qs.stringify(params, { allowDots: true })
})

service.interceptors.request.use(
  (requestConfig: InternalAxiosRequestConfig) => {
    const method = requestConfig.method?.toUpperCase()

    if (method === 'GET') {
      requestConfig.headers.set('Cache-Control', 'no-cache')
      requestConfig.headers.set('Pragma', 'no-cache')
    }

    if (method === 'POST') {
      const contentType =
        requestConfig.headers.get('Content-Type') || requestConfig.headers.get('content-type')

      if (contentType === 'application/x-www-form-urlencoded' && requestConfig.data) {
        requestConfig.data = qs.stringify(requestConfig.data)
      }
    }

    return requestConfig
  },
  (error: AxiosError) => Promise.reject(error)
)

service.interceptors.response.use(
  (response: AxiosResponse) => {
    const { data } = response

    if (response.request.responseType === 'blob' || response.request.responseType === 'arraybuffer') {
      return response
    }

    if (!data) {
      return Promise.reject(new Error('请求没有返回数据'))
    }

    const code = data.code ?? result_code
    const message = data.msg || errorCode[String(code)] || errorCode.default

    if (code !== 0 && code !== result_code) {
      return Promise.reject(new Error(message))
    }

    return response
  },
  (error: AxiosError) => {
    const responseMessage = error.response?.data
    const status = error.response?.status

    if (typeof responseMessage === 'object' && responseMessage && 'msg' in responseMessage) {
      return Promise.reject(new Error(String(responseMessage.msg)))
    }

    if (error.message === 'Network Error') {
      return Promise.reject(new Error('网络异常，请检查网络连接'))
    }

    if (error.message.includes('timeout')) {
      return Promise.reject(new Error('请求超时，请稍后重试'))
    }

    if (status) {
      return Promise.reject(new Error(errorCode[String(status)] || errorCode.default))
    }

    return Promise.reject(error)
  }
)

export { service }
